import { useState, useCallback, useEffect } from "react";
import { ZOOM_LEVELS, DEFAULT_ZOOM, MIN_ZOOM, ZOOM_STEP } from "../../constants";

interface UseImageZoomOptions {
  open: boolean;
  fileId: string;
}

export function useImageZoom({ open, fileId }: UseImageZoomOptions) {
  const [zoom, setZoom] = useState(DEFAULT_ZOOM);

  useEffect(() => {
    if (open) {
      setZoom(DEFAULT_ZOOM);
    }
  }, [fileId, open]);

  const handleZoomIn = useCallback(() => {
    setZoom((prev) => {
      const currentIndex = ZOOM_LEVELS.indexOf(
        prev as (typeof ZOOM_LEVELS)[number]
      );
      const newZoom =
        currentIndex < ZOOM_LEVELS.length - 1
          ? ZOOM_LEVELS[currentIndex + 1]
          : prev * ZOOM_STEP;
      return newZoom;
    });
  }, []);

  const handleZoomOut = useCallback(() => {
    setZoom((prev) => {
      const currentIndex = ZOOM_LEVELS.indexOf(
        prev as (typeof ZOOM_LEVELS)[number]
      );
      const newZoom =
        currentIndex > 0
          ? ZOOM_LEVELS[currentIndex - 1]
          : Math.max(MIN_ZOOM, prev / ZOOM_STEP);
      return newZoom;
    });
  }, []);

  const handleResetZoom = useCallback(() => {
    setZoom(DEFAULT_ZOOM);
  }, []);

  return {
    zoom,
    handleZoomIn,
    handleZoomOut,
    handleResetZoom,
  };
}
